const accountTypes = {
    mediaType: 'media-type',
    social: 'social',
    broadcast: 'broadcast',
    owned: 'owned',
};

export default accountTypes;
